/**
 * HTTP header values must be ISO-8859-1 (Latin-1). File names routinely contain
 * characters outside that range — most commonly macOS screenshots, whose
 * timestamp uses a U+202F narrow no-break space before "AM"/"PM". Passing such a
 * name straight into a `fetch()` header (e.g. `X-File-Name`) makes the browser
 * throw a `TypeError`, which surfaced to users as "Post failed — Type error"
 * when attaching those screenshots.
 *
 * The server only uses this name cosmetically (as a label inside the blob path,
 * alongside a random suffix), so a lossy ASCII fallback is safe.
 */
export function toHeaderSafeFileName(
  name: string | undefined | null,
  fallback = "upload",
): string {
  const trimmed = (name ?? "").trim();
  if (!trimmed) return fallback;
  // Replace any character outside printable ASCII (control chars and any
  // non-Latin-1 code point) with an underscore so the result is header-safe.
  const safe = trimmed.replace(/[^\x20-\x7E]/g, "_");
  return safe.trim() || fallback;
}
